import { render, staticRenderFns } from "./DimensionsEditor.vue?vue&type=template&id=f50e8292&"
import script from "./DimensionsEditor.vue?vue&type=script&lang=ts&"
export * from "./DimensionsEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports